<!-- MODAL seleccionImpuesto -->
<div mdbModal style="overflow-y: auto;" #seleccionImpuesto="mdb-modal" class="modal fade" id="basicExample"
    tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-fluid" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 *ngIf="mode==='SELECT'" class="modal-title w-100 text-left" id="myModalLabel">
                    Seleccionar impuesto adicional
                </h4>
                <h4 *ngIf="mode==='VIEW'" class="modal-title w-100 text-left" id="myModalLabel">
                    Consulta impuesto adicional
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="seleccionImpuesto.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">

                    <div class="col">
                        <table class="table table-striped table-hover table-sm align-middle">
                            <thead>
                                <tr>
                                    <th scope="col">Nombre</th>
                                    <th scope="col">Detalle</th>
                                    <th scope="col" class="nowrap">% Porcentaje</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngIf="!listaImpuesto || listaImpuesto.length === 0">
                                    <td colspan="4" style="text-align: center;">
                                        No se encontro informacion
                                    </td>
                                </tr>
                                <tr *ngFor="let imp of listaImpuesto">
                                    <td style="white-space: pre-wrap;">{{ imp.nombre }}</td>
                                    <td style="white-space: pre-wrap;">{{ imp.descripcion }}</td>
                                    <td align="center">{{ imp.valor }}</td>

                                    <td *ngIf="mode==='SELECT'">
                                        <Button *ngIf="codigo_impuesto == 0" mdbBtn type="button" color="indigo"
                                            mdbWavesEffect class="btn" size="sm"
                                            (click)="capturaImpuesto(imp.codigo)">Deseleccionado</Button>
                                        <Button *ngIf="codigo_impuesto == imp.codigo" mdbBtn type="button"
                                            color="indigo" mdbWavesEffect class="btn" size="sm"
                                            (click)="capturaImpuestoCero()">
                                            <mdb-icon fas icon="check"></mdb-icon>Seleccionado
                                        </Button>
                                    </td>
                                    <td *ngIf="mode==='VIEW'">
                                        <span class="value" *ngIf="codigo_impuesto == 0">
                                            <mdb-badge pill="true" danger="true">Deseleccionado</mdb-badge>
                                        </span>
                                        <span class="value" *ngIf="codigo_impuesto == imp.codigo">
                                            <mdb-badge pill="true" success="true">
                                                <mdb-icon fas icon="check"></mdb-icon> Seleccionado
                                            </mdb-badge>
                                        </span>
                                    </td>

                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-sm btn-default waves-light" size="sm" data-dismiss="modal"
                    (click)="seleccionImpuesto.hide()" mdbWavesEffect>Cerrar</button>
            </div>
        </div>
    </div>
</div>